import { render, staticRenderFns } from "./AddTextDialog.vue?vue&type=template&id=5edad1b2&"
import script from "./AddTextDialog.vue?vue&type=script&lang=js&"
export * from "./AddTextDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports